export enum TYPE_STATUS_ORDER {
  PENDENTE = 'PENDENTE',
  ESCALADO = 'ESCALADO',
  CANCELADO = 'CANCELADO',
}

export enum TYPE_STATUS_ITEM {
  AWAITING = 'AWAITING',
  APPROVED = 'APPROVED',
  REPROVED = 'REPROVED',
  SELECTED = 'SELECTED',
  DELETED = 'DELETED',
  CANCELLED = 'CANCELLED',
  INVOICED = 'INVOICED',
  PARTIALLY_INVOICED = 'PARTIALLY_INVOICED',
  CHECKED = 'CHECKED',
}
